import BaseModelAPI from '../BaseModelAPI';

export default class StockOpnameList extends BaseModelAPI {

	static entity = 'stockopnamelist'
	static entityName = 'stockopname';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
